module.exports = __webpack_public_path__ + "assets/565dc13d2d2d3a31a7d6e4d118f0ec11.png";